import { useTranslation } from '@hooks/useTranslation';
import logo_beneficios from "@assets/images/logo_beneficios.svg";

function CardBenefits() {

  const { translate } = useTranslation();
  
  return (
    <div>
      <div className="title subtitle">{translate('benefits.title')}</div>
      <hr />

      <div className="grid-columns">
        <div className="column amber">
          <div className="header">
            <span className="dot"></span>
            <h3>Amber</h3>
            <img src={logo_beneficios} alt="Art on U" className="logo" />
          </div>
          <div className="crystals">{translate('benefits.amber.cristals')}</div>
          <ul className="benefits">
            <li>
              <span className="icon"></span>
              <div>
                <h4>{translate('benefits.amber.benefits_title_1')}</h4>
                <p>{translate('benefits.amber.benefits_description_1')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
                <h4>{translate('benefits.amber.benefits_title_2')}</h4>
                <p>{translate('benefits.amber.benefits_description_2')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
                <h4>{translate('benefits.amber.benefits_title_3')}</h4>
                <p>{translate('benefits.amber.benefits_description_3')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
                <h4>{translate('benefits.amber.benefits_title_4')}</h4>
                <p>{translate('benefits.amber.benefits_description_4')} </p>
              </div>
            </li>

          </ul>
          <div className="pleca"></div>
        </div>

        <div className="column emerald">
          <div className="header">
            <span className="dot"></span>
            <h3>Emerald</h3>
            <img src={logo_beneficios} alt="Art on U" className="logo" />
          </div>
          <div className="crystals">{translate('benefits.emerald.cristals')}</div>
          <ul className="benefits">
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_1')}</h4>
              <p>{translate('benefits.emerald.benefits_description_1')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_2')}</h4>
              <p>{translate('benefits.emerald.benefits_description_2')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_3')}</h4>
              <p>{translate('benefits.emerald.benefits_description_3')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_4')}</h4>
              <p>{translate('benefits.emerald.benefits_description_4')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_5')}</h4>
              <p>{translate('benefits.emerald.benefits_description_5')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.emerald.benefits_title_6')}</h4>
              <p>{translate('benefits.emerald.benefits_description_6')} </p>
              </div>
            </li>
          </ul>
          <div className="pleca"></div>
        </div>

        <div className="column diamond">
          <div className="header">
            <span className="dot"></span>
            <h3>Diamond</h3>
            <img src={logo_beneficios} alt="Art on U" className="logo" />
          </div>
          <div className="crystals">{translate('benefits.diamond.cristals')}</div>
          <ul className="benefits">
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_1')}</h4>
              <p>{translate('benefits.diamond.benefits_description_1')} </p>
               </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_2')}</h4>
              <p>{translate('benefits.diamond.benefits_description_2')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_3')}</h4>
              <p>{translate('benefits.diamond.benefits_description_3')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_4')}</h4>
              <p>{translate('benefits.diamond.benefits_description_4')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_5')}</h4>
              <p>{translate('benefits.diamond.benefits_description_5')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_6')}</h4>
              <p>{translate('benefits.diamond.benefits_description_6')} </p>
              </div>
            </li>
            <li>
              <span className="icon"></span>
              <div>
              <h4>{translate('benefits.diamond.benefits_title_7')}</h4>
              <p>{translate('benefits.diamond.benefits_description_7')} </p>
              </div>
            </li>
            
          </ul>
          <div className="pleca"></div>
        </div>
      </div>
    </div>
  )
}

export default CardBenefits
